<template>
  <footer class="footer-section">
    <!-- 정보 영역 -->
    <div class="footer-info">
      <div class="footer-left">
        <p class="notice">본 사이트는 엘리프 한신더휴 수원 분양 상담 안내를 위한 정보 제공 페이지입니다.</p>
        <p class="company">운영사 : 주식회사 한걸음 &nbsp;|&nbsp; 이메일 : info@step1.kr</p>
        <p class="disclaimer">※ 본 사이트는 분양 상담 및 방문 예약 안내를 위한 사이트이며,<br>사업 및 분양과 관련된 자세한 사항은 상담을 통해 안내받으실 수 있습니다.</p>
      </div>
      <div class="footer-right">
        <router-link to="/privacy" class="privacy-link">개인정보처리방침</router-link>
      </div>
    </div>

    <div class="footer-bottom">
      <p class="copyright">Copyright &copy; 2026 엘리프 한신더휴 수원. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

<style scoped>
.footer-section {
  background: #111;
  padding: 50px 80px 40px;
}

.footer-info {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 40px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-left {
  flex: 1;
}

.notice {
  font-family: var(--font-family);
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.8;
  margin-bottom: 12px;
}

.company {
  font-family: var(--font-family);
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.35);
  line-height: 1.8;
  margin-bottom: 12px;
}

.disclaimer {
  font-family: var(--font-family);
  font-size: 11px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.25);
  line-height: 1.8;
}

.footer-right {
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
}

.privacy-link {
  font-family: var(--font-family);
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  padding: 6px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  transition: all 0.3s ease;
}

.privacy-link:hover {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.5);
}

.footer-bottom {
  padding-top: 24px;
}

.copyright {
  font-family: var(--font-family2);
  font-size: 11px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.2);
  letter-spacing: 1px;
}

@media (max-width: 768px) {
  .footer-section {
    padding: 32px 24px 120px;
  }

  .footer-info {
    flex-direction: column;
    gap: 20px;
  }

  .footer-right {
    order: -1;
  }

  .notice {
    font-size: 12px;
  }

  .company {
    font-size: 11px;
  }

  .disclaimer {
    font-size: 10px;
    word-break: keep-all;
  }

  .copyright {
    font-size: 10px;
  }
}
</style>
